import BaseModule from './base-module';

// 全局基础
class Base extends BaseModule {
  // 登录
  login(params) {
    return this.post('/admin/i_lis_login/login', params);
  }
  // 菜单列表
  tree(params) {
    return this.get('/adminMenu/tree', { params });
  }
  //公司信息
  compamyInfo() {
    return this.post('/admin/i_lis/getCompany');
  }
  //修改公司信息
  upddateCompany(params) {
    return this.post('/admin/i_lis/updateCompany', params);
  }
}

export default new Base();
